export default defineNuxtRouteMiddleware((to, from) => {
  const selectedServices = useState('selectedServices', () => ({}));
  const booking = useState('booking');
  const checkout = useState('checkout');
  const { links } = useSetup();
  const linksToBeChecked = [links.value.Checkout, links.value.CheckoutDone, links.value.CheckoutUnitList]
  if(!linksToBeChecked.includes(to.path) && linksToBeChecked.includes(from.path)) {
    selectedServices.value = {}
    if(import.meta.client) sessionStorage.setItem('selectedServices', JSON.stringify(selectedServices.value));
    
    if (booking.value) {
      booking.value.package_external_id = '';
      booking.value.rate_external_id = '';
      booking.value.selected_units = [];
      booking.value.selected_rate_name = '';
    }

    if (checkout.value?.comments) checkout.value.comments = '';
    
    const _query = { ...to.query }
    for (let item of ['package_external_id', 'rate_external_id', 'selected_units', 'selected_rate_name']) {
      if (_query[item]) delete _query[item]
    }
    
    if (JSON.stringify(_query) !== JSON.stringify(to.query)) {
      // Using abortNavigation + navigateTo pattern to avoid infinite loop
      abortNavigation()
      return navigateTo({
        path: to.path,
        query: _query
      })
    }
  }
})